import React, { useContext } from 'react';



function Footer() {


  return (
    <>

        
    </>
  );
}

export default Footer;